import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _createClass from '@babel/runtime/helpers/createClass';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _wrapNativeSuper from '@babel/runtime/helpers/wrapNativeSuper';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import cookies from '../node_modules/@buzzfeed/bf-utils/lib/cookies/index.js';
import uuid4 from '../node_modules/@buzzfeed/bf-utils/lib/uuid4/index.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Processes the string to
 * - Remove disallowed characters
 * - Replace spaces with an underscore
 * - Convert case to lowercase
 * @param {String} - dirty string
 * @return {String} - processed "cleaned up" string
 */

var cleanString = function cleanString(input) {
  // https://regex101.com/r/stkYZw/2
  // https://regex101.com/r/m3kM50/2
  return String(input).replace(/[^\w\s-_/]/g, '').replace(/\s+/g, '_').toLowerCase();
};
/**
 * Additional checking Source fields
 * @param [items]
 */

var cleanSourceFields = function cleanSourceFields(items) {
  return items.map(function (item) {
    return item === 'undefined' ? '' : item;
  });
};
/**
 * Takes an input and returns an integer representation. A value of `null` will be returned if the
 * input can not be converted.
 * @param  {any} num - Input to convert to integer
 * @return {integer|Null}
 */

var convertToInteger = function convertToInteger(num) {
  return num === null || isNaN(Number(num)) ? null : Number(num);
};
/**
 * Check if input is an array and return it, otherwise return an empty array.
 * @param  {any} data
 * @return {Array}
 */

var getArray = function getArray(data) {
  var default_value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return data && Array.isArray(data) ? data : default_value;
};
/**
 * Generates a data object by evaluating all supplied data layers.
 * All layers are always represented as an append-only list.
 */

var getDataFromLayers = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var context, _ref$layers, layers, data_obj, i, layer;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            context = _ref.context, _ref$layers = _ref.layers, layers = _ref$layers === void 0 ? [] : _ref$layers;
            data_obj = {};
            i = 0;

          case 3:
            if (!(i < layers.length)) {
              _context.next = 13;
              break;
            }

            layer = layers[i];

            if (!(typeof layer === 'function')) {
              _context.next = 9;
              break;
            }

            _context.next = 8;
            return layer(context);

          case 8:
            layer = _context.sent;

          case 9:
            data_obj = _objectSpread(_objectSpread({}, data_obj), layer);

          case 10:
            i++;
            _context.next = 3;
            break;

          case 13:
            return _context.abrupt("return", data_obj);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getDataFromLayers(_x) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Coordinates linking client_uuid with AMP events when a visitor moves from viewing a non-AMP page into viewing an AMP page.
 * - Gets the AMP client ID from cookie if it exists (will exist if user first visits AMP version of page)
 * - If the AMP client ID is not set, generate the AMP client ID and set the cookie.
 * @param  {String} options.client_id_cookie_name - dev, stage, prod
 * @param  {Number} options.expires - Cookie expiration. Defaults to 1 year to match expiration of cookie set if hitting AMP first
 * @return {String}
 */

var getAmpClientId = function getAmpClientId() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$client_id_cooki = _ref3.client_id_cookie_name,
      client_id_cookie_name = _ref3$client_id_cooki === void 0 ? '_amp_pd' : _ref3$client_id_cooki,
      _ref3$expires = _ref3.expires,
      expires = _ref3$expires === void 0 ? 365 : _ref3$expires;

  var client_id = cookies.get(client_id_cookie_name);

  if (!client_id) {
    /**
     * Will get the top level domain for any environment (dev, stage, prod). Examples:
     * https://tasty-ui.dev.buzzfeed.io       -> buzzfeed.io
     * https://tasty-ui.sso.stage.buzzfeed.io -> buzzfeed.io
     * https://stage.tasty.co                 -> tasty.co
     * https://tasty.co                       -> tasty.co
     * https://stage.buzzfeed.com             -> buzzfeed.com
     * https://www.buzzfeed.com               -> buzzfeed.com
     * @type {String}
     */
    var top_level_domain = window.location.hostname.split('.').splice(-2, 2).join('.');
    client_id = "amp-".concat(uuid4());
    cookies.set({
      name: client_id_cookie_name,
      value: client_id,
      days: expires,
      domain: top_level_domain
    });
  }

  return client_id;
};

var ClientEventSchemaLayerError = /*#__PURE__*/function (_Error) {
  _inherits(ClientEventSchemaLayerError, _Error);

  var _super = _createSuper(ClientEventSchemaLayerError);

  function ClientEventSchemaLayerError(message) {
    var _this;

    _classCallCheck(this, ClientEventSchemaLayerError);

    _this = _super.call(this, message);
    _this.name = 'ClientEventSchemaLayerError';
    return _this;
  }

  return _createClass(ClientEventSchemaLayerError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var isRequired = function isRequired() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return new ClientEventSchemaLayerError("Missing required field: \"".concat(name, "\""));
};
/**
 * Removes all entries containing ClientEventSchemaLayerError instances from a given data object.
 * Also, if debug flag is true, warnings are logged to the console with the supplied Error.
 *
 * The reason that a warning is logged instead of throwing an error is because the data registry
 * API isn't versioned in the same way that our packages are. So in theory, someone could update
 * the data registry API to make a field not required, push out that change, and then we'd see JS
 * errors in services if the packages were not updated at the same time. With errors, if uncaught,
 * might crash out other page JS, and we don't want a bad tracking event to block the overall user
 * experience! Warnings would give us the same debugging power with less potential negative impact.
 * @param {Object} data - a data object produced by evaluating all data layers into a flat object (see `getDataFromLayers`).
 * @param {boolean} options.debug - Flag for determining if warnings should be logged to console
 * @return {Object}
 */

var validateLayerData = function validateLayerData(data) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref4$debug = _ref4.debug,
      debug = _ref4$debug === void 0 ? false : _ref4$debug;

  var valid_entries = Object.entries(data).filter(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        value = _ref6[1];

    if (value instanceof ClientEventSchemaLayerError) {
      // Only when debug is true (dev and stage) we output the errors as warnings to the console
      debug && console.warn(value);
      return false;
    }

    return true;
  });
  /**
   * Note: while Object.fromEntries would simplify this code, it's only supported in Node >= 12
   */

  var event_data = valid_entries.reduce(function (object_from_entries, _ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        key = _ref8[0],
        value = _ref8[1];

    object_from_entries[key] = value;
    return object_from_entries;
  }, {});
  return event_data;
};

export { cleanSourceFields, cleanString, convertToInteger, getAmpClientId, getArray, getDataFromLayers, isRequired, validateLayerData };
